import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { Box } from '@cp/ds/src/components/box';
import { Button } from '@cp/ds/src/components/button';
import { FormField } from '@cp/ds/src/components/form';
import { Stack } from '@cp/ds/src/components/stack';
import { ArrowRightIcon } from '@cp/ds/src/icons/arrowRight';
import React from 'react';
import { FormProvider } from 'react-hook-form';
import { SupportSendMessageFormViewProps } from './model';

export const View: React.FC<SupportSendMessageFormViewProps> = ({ form, onSubmit }) => {
  const theme = useTheme();
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = form;

  return (
    <FormProvider {...form}>
      <Box component="form" onSubmit={handleSubmit(onSubmit)}>
        <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 2, md: 2.5 }, mb: { xs: 2, md: 2.5 } }}>
          <FormField
            name="name"
            placeholder="Имя"
            sx={{ background: theme.palette.background.default, borderRadius: `${theme.borderRadius.normal}px` }}
            type="text"
          />
          <FormField
            name="email"
            placeholder="Почта"
            sx={{ background: theme.palette.background.default, borderRadius: `${theme.borderRadius.normal}px` }}
            type="email"
          />
        </Stack>
        <FormField
          fieldContainerProps={{ sx: { mb: { xs: 2, md: 2.5 } } }}
          name="message"
          placeholder="Сообщение"
          sx={{ background: theme.palette.background.default, borderRadius: `${theme.borderRadius.normal}px`, width: 1 }}
          type="textArea"
        />
        <Stack alignItems={{ xs: 'flex-start', md: 'center' }} direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between">
          <FormField
            fieldContainerProps={{
              sx: { display: 'flex', flexDirection: 'column', justifyContent: 'center', maxWidth: '50%', mr: 1, mb: { xs: 2, md: 0 } },
            }}
            labelText="Прикрепить файл"
            name="attachments"
            type="file"
          />
          <Button disabled={isSubmitting} icon={<ArrowRightIcon />} type="submit">
            Отправить
          </Button>
        </Stack>
      </Box>
    </FormProvider>
  );
};
